import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input']

  increment(event) {
    event.preventDefault()
    this.#setValue(this.#value + 1)
  }

  decrement(event) {
    event.preventDefault()
    this.#setValue(this.#value - 1)
  }

  get #value() {
    const value = parseInt(this.inputTarget.value, 10)
    return Number.isNaN(value) ? 0 : value
  }

  get #max() {
    const max = parseInt(this.inputTarget.dataset.max, 10)
    return Number.isNaN(max) ? Number.MAX_SAFE_INTEGER : max
  }

  #setValue(value) {
    const bounded = Math.min(Math.max(value, 0), this.#max)
    if (bounded === this.#value) return

    this.inputTarget.value = bounded
    this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }))
  }
}
